import Component from '../../components/Component';

import keys from './keys';
import query from './query';
import ListData from '../../components/ListData';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    componentDidUpdate() {
        if (this.state.data && !this.state.data.length && !this.props.emptyEntities) {
            this.props.setIsEmpty(true);
        }
    }

    render() {
        return (
            <ListData
                loading={this.state.loading}
                header={this.props.header ?? 'Top Entities'}
                subheader={this.props.subheader ?? '(by relevancy)'}
                forceRun={this.forceRun}
                link={this.props.link}
                keys={keys}
                uniqKey="name"
                data={this.state.data}
                cardClassName={'list-data-full'}
            />
        );
    }
}

export default Summary;
